import React, { useContext } from "react";
import { themeContext } from "../../Context";
import "./Experience.css";
import Exp from'./exp.png';
import Certificate from './certificate.pdf';
const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="experience" id='experience'>
      <div className="achievement">
        {/* darkMode */}
        <div className="circle" style={{color: darkMode?'var(--orange)':''}}>1+</div>
        <span  style={{color: darkMode?'white':''}}>years </span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{color: darkMode?'var(--orange)':''}}>10+</div>
        <span  style={{color: darkMode?'white':''}}>completed </span>
        <span>Projects</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{color: darkMode?'var(--orange)':''}}>
          <a href={Certificate} download style={{transform:'scale(.08)'}}>
          <img src={Exp} alt="" style={{transform:'scale(.8)'}}/>
          </a>
          </div>
        <span  style={{color: darkMode?'white':''}}>Certified</span>
        <span>Front-End Developer</span>
      </div>
    </div>
  );
};

export default Experience;